export const getLayerHeight = buttonWidth => buttonWidth * 0.1